import React, {useEffect} from "react";
import FromToPage from "../../components/FromToPage";
import {useDispatch, useSelector} from "react-redux";
import styles from "./style.module.css";
import langData from "../../lang/data";
import {getReportingPageData} from "../../store/MainSlice";
import PageSeo from "../../components/PageSeo";

export default function Reporting() {
    const dispatch = useDispatch();

    const {currentLanguage, ReportingData} = useSelector(({main}) => main);
    const siteUrl = process.env.REACT_APP_STORAGE_URL;

    useEffect(() => {
        dispatch(getReportingPageData());
    }, [dispatch]);

    return (
        <>
            <PageSeo pageKey="reporting" />
            <div className="wrapper">
            <FromToPage
                pages={[
                    {
                        label: langData.footer.Information.reporting[currentLanguage],
                        value: "/reporting",
                        active: true,
                    },
                ]}
            />
            <h1 style={{ margin: "0 0 16px", fontSize: "24px" }}>
                {langData.footer.Information.reporting[currentLanguage]}
            </h1>

            <div className={styles.ArticleSection}>
                <div className={styles.main}>
                    <div className={styles.gridContainer}>
                        {ReportingData && ReportingData.length > 0 ? (
                            ReportingData.map((item, index) => (
                                <div key={index} className={styles.gridItem}>
                                    {item?.file_path ? (
                                        <a
                                            href={`${siteUrl}${item.file_path}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img
                                                src="public/pdf-svgrepo-com.svg"
                                                alt={item?.["title_" + currentLanguage] || `item-${index}`}
                                                className={styles.icon}
                                            />
                                            <p>{item?.["title_" + currentLanguage]}</p>
                                        </a>
                                    ) : (
                                        <div className={styles.emptyItem}>
                                            <svg
                                                width="100"
                                                height="100"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                className={styles.icon}
                                            >
                                                <path
                                                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10
                                                        10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                                                    fill="#ccc"
                                                />
                                            </svg>
                                            <p>{langData.footer.Information.noFile[currentLanguage] || "Файл отсутствует"}</p>
                                        </div>
                                    )}
                                </div>
                            ))
                        ) : (
                            <div className={styles.noData}>
                                <svg
                                    width="100"
                                    height="100"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    className={styles.icon}
                                >
                                    <path
                                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10
                                                10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                                        fill="#ccc"
                                    />
                                </svg>
                                <p>  {langData.footer.Information.noReportingData[currentLanguage] || "Нет данных"}</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}
